// Botão + flutuante (0.65, B9; texto 11d F): o "+" cria o que a tela ABERTA mostra, acompanhando a sub-aba.
// No My Planner cria uma tarefa. Telas que não registram nada (Mensagens, Ajustes, Abas, telas só de leitura ou
// de configuração) deixam o + "apagadinho" e o toque mostra um aviso curto. Segurar o + cria sempre uma tarefa.
//
// 11d F (causa do + que "não fazia nada"): as abas da barra continuam montadas quando se troca de aba, e o registro
// antigo valia "o último que montou", estivesse na tela ou não. Assim o + de Anotações, Diário, Projeto de vida,
// Hábitos... rodava a ação de OUTRA aba escondida (ex.: criava uma caixa lá no fim de Anotações). Agora só vale o
// registro de quem está em foco, e o mais "de dentro" (o que montou por último) ganha.
import { useEffect, useRef, useSyncExternalStore } from 'react';
import { useIsFocused } from 'expo-router';

type Novo = { rotulo: string; fn: () => void };
type Reg = { ordem: number; ref: { current: Novo | null } };
let ativos: Reg[] = [];
let seq = 0;
let versao = 0;
const ouvintes = new Set<() => void>();
const avisar = () => { versao++; ouvintes.forEach(f => f()); };

/** A tela diz o que o + faz enquanto ela está aberta e em foco. null = esta tela não cria nada (+ apagadinho). */
export function useBotaoNovo(novo: Novo | null) {
  const ref = useRef<Novo | null>(novo);
  ref.current = novo;
  // ordem de montagem (render: o pai antes do filho), para o filho ganhar mesmo quando a aba volta ao foco
  const ordem = useRef(0);
  if (!ordem.current) ordem.current = ++seq;
  const foco = useIsFocused();
  const tem = !!novo && foco;
  useEffect(() => {
    if (!tem) return;
    const reg: Reg = { ordem: ordem.current, ref };
    ativos = [...ativos, reg].sort((a, b) => a.ordem - b.ordem);
    avisar();
    return () => { ativos = ativos.filter(x => x !== reg); avisar(); };
  }, [tem]);
  // o rótulo mudou (ex.: outra sub-aba): a barra atualiza o nome lido pelo leitor de tela
  const rotulo = novo?.rotulo;
  useEffect(() => { if (tem) avisar(); }, [rotulo]); // eslint-disable-line react-hooks/exhaustive-deps
}
/** O que o + faz agora (lido na hora do toque), ou null: nada a adicionar nesta tela. */
export const novoAtual = (): Novo | null => ativos[ativos.length - 1]?.ref.current ?? null;
export function useNovoAtual() {
  useSyncExternalStore(cb => { ouvintes.add(cb); return () => ouvintes.delete(cb); }, () => versao);
  return novoAtual();
}
